/* eslint-disable no-console */
import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import ApplicationDetails from './ApplicationDetails';

const TransparentBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1000;
`;
const CloseContainer = styled.div`
  display: flex;
  color: #ffffff;
  font-family: acumin-pro;
  font-size: 14px;
  align-items: center;
  width: 100%;

  justify-content: flex-end;
  min-height: 40px;
  max-height: 40px;
  @media screen and ${(props) => props.theme.breakpoints.lg} {
    width: 60%;
  }
`;
const TopCloseButton = styled.div`
  display: flex;
  cursor: pointer;
  align-items: center;
  user-select: none;
`;
const CloseButtonContainer = styled.div`
  display: flex;
  margin: 35px;
  justify-content: flex-end;
`;
const CloseButton = styled.div`
  height: 37px;
  width: 136px;
  border-radius: 6px;
  background-color: #D73714;
  justify-content: center;
  align-items: center;
  display: flex;
  color: #ffffff;
  font-family: acumin-pro;
  font-weight: 600;
  cursor: pointer;
  user-select: none;
`;
const CloseIcon = styled(FontAwesomeIcon)`
  color: #ffffff;
  font-size: 1.5em;
  margin-left: 10px;
`;
const ModalBackground = styled.div`
  background: #ffffff;
  width: 100%;
  margin-bottom: 20px;
  overflow: auto;
  @media screen and ${(props) => props.theme.breakpoints.lg} {
    width: 60%;
  }
`;
const TopBar = styled.div`
  height: 37px;
  background-color: #D73714;
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    text-align: center;
    color: #ffffff;
    font-family: acumin-pro;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 19px;
  }
`;
const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
`;

const ApplicationDetailsModal = ({
  modalToggle,
  applicantId,
  applicantDetailsList,
}: {
  modalToggle: any;
  applicantId: number;
  applicantDetailsList: any;
}) => {
  const { t } = useTranslation();
  const applicantDetails = applicantDetailsList[applicantId].profile_features;
  const applicantName = `${applicantDetails.user.first_name} ${applicantDetails.user.last_name}`;

  return (
    <TransparentBackground>
      <CloseContainer>
        <TopCloseButton onClick={() => modalToggle(false)}>
          <div>{t('close')}</div>
          <CloseIcon icon={['fal', 'times-circle']} />
        </TopCloseButton>
      </CloseContainer>
      <ModalBackground>
        <TopBar>
          <span>{`${applicantName} #${applicantDetails.id}`}</span>
        </TopBar>
        <ModalContent>
          <ApplicationDetails
            applicantName={applicantName}
            applicantDetails={applicantDetails}
            additionalInfo={{
              phone: applicantDetails.user?.phone,
              email: applicantDetails.user?.email,
            }}
          />
        </ModalContent>
        <CloseButtonContainer>
          <CloseButton onClick={() => modalToggle(false)}>
            {t('close')}
          </CloseButton>
        </CloseButtonContainer>
      </ModalBackground>
    </TransparentBackground>
  );
};

export default ApplicationDetailsModal;
